import { TextField, ReferenceField, FunctionField } from "react-admin";
import { EmptyState } from "../components/EmptyState";
import { joinAddressLine } from "../components/raFormat";
import {
  AppList,
  AppListDefaultActions,
  AppListFilterCard,
  AppDatagrid,
  AppRowActions,
  SearchFilterInput,
  ReferenceFilterInput,
  ListEditButton,
} from "@/adapters/inbound/layout";

export const ConstructionSiteList = () => (
  <AppList
    perPage={25}
    sort={{ field: "updatedAt", order: "DESC" }}
    empty={
      <EmptyState
        title="Keine Einsatzorte"
        hint="Legen Sie Einsatzorte an, um Aufträge schneller zu erstellen und Adressen wiederzuverwenden."
      />
    }
  >
    <AppListDefaultActions />

    <AppListFilterCard
      search={<SearchFilterInput source="q" label="Suche" />}
      filters={
        <ReferenceFilterInput
          source="clientId"
          reference="clients"
          label="Kunde"
          autocompleteProps={{
            optionText: "name",
          }}
        />
      }
    />

    <AppDatagrid rowClick="show">
      <TextField source="label" label="Bezeichnung" sortable emptyText="—" />

      <ReferenceField
        source="clientId"
        reference="clients"
        link="show"
        label="Kunde"
      >
        <TextField source="name" />
      </ReferenceField>

      <ReferenceField
        source="addressId"
        reference="addresses"
        link="show"
        label="Adresse"
      >
        <FunctionField render={(a: any) => joinAddressLine(a)} />
      </ReferenceField>

      <FunctionField
        label={false}
        render={() => (
          <AppRowActions>
            <ListEditButton />
          </AppRowActions>
        )}
      />
    </AppDatagrid>
  </AppList>
);
